// @flow

import React from "react";
import { Portal } from "@chakra-ui/react";

import { StyledReports } from "./styles";
import Table from "./Table";
import MenuBar from "./MenuBar";
import Navigation from "src/components/Manage/Navigation";

const Reports = () => {
  return (
    <Portal>
      <StyledReports>
        <Navigation tab="user-reports" />
        <MenuBar />
        <Table />
      </StyledReports>
    </Portal>
  );
};

export default Reports;
